// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL: 'https://localhost:7334/api',
  hubURL: 'https://localhost:7334/hub',
  forgotPasswordUrl: 'https://agent3.amsqa.williston.local/AMS2/Site/Logon#site/forgotpassword',
  appName: 'ID Verification',
  version: '1.0.0'
};